module.exports = {"description":"","displayName":"NessieLogo","methods":[],"props":{"cssMap":{"defaultValue":{"value":"require( './nessieLogo.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/NessieLogo-props.json
// module id = 448
// module chunks = 0